import EV from '@dadajam4/ev';
import visibilityManager from '@dadajam4/visibility';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

if (typeof document !== 'undefined' && !document.scrollingElement) {
    var judged_1 = false;
    var element_1 = null;
    var scrollingElement = function () {
        if (judged_1)
            return element_1;
        if (!document.documentElement)
            return element_1;
        if (document.body.scrollTop) {
            judged_1 = true;
            return (element_1 = document.body);
        }
        var iframe = document.createElement('iframe');
        iframe.style.height = '1px';
        document.documentElement.appendChild(iframe);
        if (!iframe.contentWindow)
            return element_1;
        var doc = iframe.contentWindow.document;
        doc.write('<!DOCTYPE html><div style="height:9999em">x</div>');
        doc.close();
        if (!doc.documentElement)
            return element_1;
        var isCompliant = doc.documentElement.scrollHeight > doc.body.scrollHeight;
        iframe.parentNode.removeChild(iframe);
        judged_1 = true;
        return (element_1 = isCompliant ? document.documentElement : document.body);
    };
    Object.defineProperty(document, 'scrollingElement', {
        get: scrollingElement,
    });
}

var HAS_WINDOW = typeof window !== 'undefined';
function error(message) {
    return new Error("[scroller] " + message);
}
function isDocumentElement(el) {
    return el.constructor === HTMLHtmlElement;
}
function isBodyElement(el) {
    return el.constructor === HTMLBodyElement;
}

// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
var _supportsPassive = false;
try {
    var opts = Object.defineProperty({}, 'passive', {
        get: function () {
            _supportsPassive = true;
        },
    });
    window.addEventListener('test', null, opts);
    window.removeEventListener('test', null, opts);
}
catch (e) { }
var SUPPORTS_PASSIVE = _supportsPassive;
function isBodyElement$1(el) {
    return el.tagName.toLowerCase() === 'body';
}
function getContainerDimension(el) {
    if (isBodyElement$1(el)) {
        var documentElement = document.documentElement;
        return {
            // width: window.innerWidth,
            // height: window.innerHeight,
            width: documentElement.clientWidth,
            height: documentElement.clientWidth,
        };
    }
    else {
        return {
            width: el.clientWidth,
            height: el.clientHeight,
        };
    }
}
function $(selectorOrElement) {
    if (typeof selectorOrElement !== 'string')
        return selectorOrElement;
    return document.querySelector(selectorOrElement);
}
function cumulativeOffset(element) {
    var top = 0;
    var left = 0;
    var el = element;
    while (el) {
        top += el.offsetTop || 0;
        left += el.offsetLeft || 0;
        el = el.offsetParent;
    }
    return {
        top: top,
        left: left,
    };
}
function on(element, events, handler, opts) {
    if (opts === void 0) { opts = { passive: false }; }
    if (!Array.isArray(events))
        events = [events];
    for (var i = 0; i < events.length; i++) {
        element.addEventListener(events[i], handler, SUPPORTS_PASSIVE ? opts : false);
    }
}
function off(element, events, handler) {
    if (!Array.isArray(events))
        events = [events];
    for (var i = 0; i < events.length; i++) {
        element.removeEventListener(events[i], handler);
    }
}
function error$1(message) {
    return new Error("[scroll] " + message);
}

// space: 32, page up: 33, page down: 34, end: 35, home: 36
// left: 37, up: 38, right: 39, down: 40
var SCROLLABLE_KEY_CODES = [32, 33, 34, 35, 36, 37, 38, 39, 40];
var eventListenerOptions = SUPPORTS_PASSIVE ? {
    passive: false,
} : false;
var handleWheel = function (e) {
    e.preventDefault();
};
var handleScroll = function (e) {
    var el = e.target;
    if (el && el.__ps_ctx__) {
        el.scrollTo(el.__ps_ctx__.lockPosition.x, el.__ps_ctx__.lockPosition.y);
    }
};
var handleKeydown = function (e) {
    if (e.target && ['INPUT', 'TEXTAREA'].includes(e.target.tagName)) {
        return;
    }
    if (SCROLLABLE_KEY_CODES.includes(e.which)) {
        e.preventDefault();
    }
};
function enableScroll(el) {
    var _el = el;
    if (!_el.__ps_ctx__)
        return;
    var options = _el.__ps_ctx__.options;
    _el.removeEventListener('wheel', handleWheel, eventListenerOptions);
    _el.removeEventListener('scroll', handleScroll, eventListenerOptions);
    _el.removeEventListener('keydown', handleKeydown);
    if (options.hideScrollbar) {
        _el.style.overflow = _el.__ps_ctx__.overflowOrigin;
    }
    delete _el.__ps_ctx__;
}
function disableScroll(el, opts) {
    if (opts === void 0) { opts = {}; }
    var _a = opts.hideScrollbar, hideScrollbar = _a === void 0 ? false : _a;
    var _el = el;
    if (_el.__ps_ctx__)
        return;
    var options = {
        hideScrollbar: hideScrollbar,
    };
    _el.__ps_ctx__ = {
        options: options,
        el: _el,
        overflowOrigin: _el.style.overflow,
        lockPosition: {
            x: _el.scrollLeft || _el.scrollX,
            y: _el.scrollTop || _el.scrollY,
        },
    };
    if (options.hideScrollbar) {
        _el.style.overflow = 'hidden';
    }
    _el.addEventListener('wheel', handleWheel, eventListenerOptions);
    _el.addEventListener('scroll', handleScroll, eventListenerOptions);
    _el.addEventListener('keydown', handleKeydown);
}

/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */

// These values are established by empiricism with tests (tradeoff: performance VS precision)
var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;

var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

var float32ArraySupported = typeof Float32Array === 'function';

function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
function C (aA1)      { return 3.0 * aA1; }

// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }

// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }

function binarySubdivide (aX, aA, aB, mX1, mX2) {
  var currentX, currentT, i = 0;
  do {
    currentT = aA + (aB - aA) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0.0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
  return currentT;
}

function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
   var currentSlope = getSlope(aGuessT, mX1, mX2);
   if (currentSlope === 0.0) {
     return aGuessT;
   }
   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
   aGuessT -= currentX / currentSlope;
 }
 return aGuessT;
}

function LinearEasing (x) {
  return x;
}

var src = function bezier (mX1, mY1, mX2, mY2) {
  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
    throw new Error('bezier x values must be in [0, 1] range');
  }

  if (mX1 === mY1 && mX2 === mY2) {
    return LinearEasing;
  }

  // Precompute samples table
  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
  for (var i = 0; i < kSplineTableSize; ++i) {
    sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
  }

  function getTForX (aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;

    // Interpolate to provide an initial guess for t
    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;

    var initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }

  return function BezierEasing (x) {
    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
    if (x === 0) {
      return 0;
    }
    if (x === 1) {
      return 1;
    }
    return calcBezier(getTForX(x), mY1, mY2);
  };
};

var easings = {
    ease: [0.25, 0.1, 0.25, 1.0],
    linear: [0.0, 0.0, 1.0, 1.0],
    'ease-in': [0.42, 0.0, 1.0, 1.0],
    'ease-out': [0.0, 0.0, 0.58, 1.0],
    'ease-in-out': [0.42, 0.0, 0.58, 1.0],
};

var defaultBaseSettings = {
    duration: 500,
    easing: 'ease',
    cancelable: true,
};
var defaultSettings = __assign({ get container() {
        return document.scrollingElement;
    } }, defaultBaseSettings);
var abortEvents = [
    'mousedown',
    'wheel',
    'DOMMouseScroll',
    'mousewheel',
    'keyup',
    'touchmove',
];
function scroll(diffX, diffY, options, _computedValues) {
    if (options === void 0) { options = {}; }
    var $container;
    var initialX;
    var initialY;
    var targetX;
    var targetY;
    var _options = Object.assign({}, defaultSettings, options);
    var container = _options.container, duration = _options.duration, easing = _options.easing, cancelable = _options.cancelable, onProgoress = _options.onProgoress, onCancel = _options.onCancel, onDone = _options.onDone;
    var x = diffX !== 0;
    var y = diffY !== 0;
    if (_computedValues) {
        $container = _computedValues.$container;
        initialX = _computedValues.initialX;
        initialY = _computedValues.initialY;
        targetX = _computedValues.targetX;
        targetY = _computedValues.targetY;
    }
    else {
        $container = $(container);
        if (!$container)
            throw error$1('missing container ' + container);
        initialX = $container.scrollLeft;
        initialY = $container.scrollTop;
        targetX = initialX + diffX;
        targetY = initialY + diffY;
    }
    // compute overflow and adjust values
    var scrollWidth = $container.scrollWidth, scrollHeight = $container.scrollHeight;
    var _a = getContainerDimension($container), width = _a.width, height = _a.height;
    var overflowX = targetX + width - scrollWidth;
    var overflowY = targetY + height - scrollHeight;
    if (overflowX > 0) {
        diffX -= overflowX;
        targetX -= overflowX;
    }
    if (overflowY > 0) {
        diffY -= overflowY;
        targetY -= overflowY;
    }
    //
    // Setup Temporary values
    //
    var doneResolver;
    var timeStart = 0;
    var timeElapsed;
    var callbackValues = {
        container: $container,
        progress: 0,
        aborted: false,
        abortEventSource: null,
    };
    var result = {
        cancel: canceller,
        promise: new Promise(function (resolve) {
            doneResolver = resolve;
        }),
        plans: {
            x: diffX,
            y: diffY,
        },
    };
    //
    // processes
    //
    if ((diffY === 0 && diffX === 0) ||
        !!$container.__ps_ctx__)
        return initialAbort();
    // setup easings
    var easingValues;
    if (!easing) {
        easingValues = easings.ease;
    }
    else if (typeof easing === 'string') {
        easingValues = easings[_options.easing];
    }
    else {
        easingValues = easing;
    }
    var easingFn = src.apply(src, easingValues);
    on($container, abortEvents, abortFn, { passive: true });
    window.requestAnimationFrame(step);
    return result;
    //
    // inner methods
    //
    function doneResolve() {
        doneResolver();
    }
    function canceller(e, checkCancelable) {
        if (e === void 0) { e = null; }
        if (checkCancelable === void 0) { checkCancelable = false; }
        if (checkCancelable && !cancelable)
            return;
        off($container, abortEvents, abortFn);
        callbackValues.abortEventSource = e;
        callbackValues.aborted = true;
        onCancel && onCancel(callbackValues);
    }
    function abortFn(e) {
        canceller(e, true);
    }
    function initialAbort(e) {
        if (e === void 0) { e = null; }
        canceller(e);
        doneResolve();
        return result;
    }
    function step(timestamp) {
        if (callbackValues.aborted)
            return done();
        if (!timeStart)
            timeStart = timestamp;
        timeElapsed = timestamp - timeStart;
        var progress = Math.min(timeElapsed / duration, 1);
        progress = easingFn(progress);
        callbackValues.progress = progress;
        topLeft(initialY + diffY * progress, initialX + diffX * progress);
        onProgoress && onProgoress(callbackValues);
        timeElapsed < duration ? window.requestAnimationFrame(step) : done();
    }
    function topLeft(top, left) {
        if (y)
            $container.scrollTop = top;
        if (x)
            $container.scrollLeft = left;
    }
    function done() {
        if (!callbackValues.aborted)
            topLeft(targetY, targetX);
        timeStart = 0;
        off($container, abortEvents, abortFn);
        callbackValues.progress = 1;
        doneResolve();
        if (!callbackValues.aborted && onDone)
            onDone(callbackValues);
    }
}

/**
 * 指定の差分だけコンテナをスクロールします。
 * @param diffX 横軸の移動量（px）です。デフォルトは0です。
 * @param diffY 縦軸の移動量（px）です。デフォルトは0です。
 * @param options
 */
function scrollBy(diffX, diffY, options) {
    return scroll(diffX, diffY, options);
}

/**
 * 任意の位置（px）へコンテナをスクロールします。
 * @param scrollPosition スクロール先を指定します。x, y 共にオプショナルなるです。未指定の軸は現在のスクロール値のまま保持されます。
 * @param options
 */
function scrollTo(scrollPosition, options) {
    if (options === void 0) { options = {}; }
    var x = scrollPosition.x, y = scrollPosition.y;
    var container = options.container || defaultSettings.container;
    var $container = $(container);
    if (!$container)
        throw error$1('missing container ' + container);
    var initialY = $container.scrollTop;
    var initialX = $container.scrollLeft;
    if (x === undefined)
        x = initialX;
    if (y === undefined)
        y = initialY;
    var diffX = x - initialX;
    var diffY = y - initialY;
    return scroll(diffX, diffY, options, {
        $container: $container,
        initialX: initialX,
        initialY: initialY,
        targetX: x,
        targetY: y,
    });
}

/**
 * 要素スクロール利用事のデフォルト設定です。
 * @see [[ScrollToElementSettings]]
 */
var scrollToElementSettingsDefaults = {
    offset: 0,
    x: false,
    y: true,
};
/**
 * 任意の要素の位置へスクロールします。
 * @param target
 * @param options
 */
function scrollToElement(target, options) {
    //
    // Setup Options
    //
    if (options === void 0) { options = {}; }
    var _options = Object.assign({}, scrollToElementSettingsDefaults, options);
    var x = _options.x, y = _options.y;
    var offsetSource = _options.offset;
    var offset = typeof offsetSource === 'number'
        ? { x: offsetSource, y: offsetSource }
        : offsetSource;
    //
    // Setup Elements
    //
    var $target = $(target);
    if (!$target)
        throw error$1('missing element ' + target);
    var container = _options.container || defaultSettings.container;
    var $container = $(container);
    if (!$container)
        throw error$1('missing container ' + container);
    var cumulativeOffsetContainer = cumulativeOffset($container);
    var cumulativeOffsetTarget = cumulativeOffset($target);
    var initialY = $container.scrollTop;
    var initialX = $container.scrollLeft;
    var targetY = cumulativeOffsetTarget.top - cumulativeOffsetContainer.top + offset.y;
    var targetX = cumulativeOffsetTarget.left - cumulativeOffsetContainer.left + offset.x;
    var diffX = x ? targetX - initialX : 0;
    var diffY = y ? targetY - initialY : 0;
    return scroll(diffX, diffY, _options, {
        $container: $container,
        initialX: initialX,
        initialY: initialY,
        targetX: targetX,
        targetY: targetY,
    });
}

/**
 * コンテナをいずれかの辺までスクロールします。
 * @param targets 辺を指定します。シングルの文字列、及び配列に対応しています。
 * @param options
 */
function scrollToSide(targets, options) {
    var sides = typeof targets === 'string' ? [targets] : targets;
    var position = {};
    var hasRight = sides.includes('right');
    var hasBottom = sides.includes('bottom');
    if (sides.includes('top')) {
        position.y = 0;
    }
    if (sides.includes('left')) {
        position.x = 0;
    }
    if (hasRight || hasBottom) {
        var container = (options && options.container) || defaultSettings.container;
        var $container = $(container);
        if (!$container)
            throw error$1('missing container ' + container);
        if (hasRight)
            position.x = $container.scrollWidth;
        if (hasBottom)
            position.y = $container.scrollHeight;
    }
    return scrollTo(position, options);
}
/**
 * コンテナを上辺までスクロールします。
 * @param options
 */
function scrollToTop(options) {
    return scrollToSide('top', options);
}
/**
 * コンテナを右辺までスクロールします。
 * @param options
 */
function scrollToRight(options) {
    return scrollToSide('right', options);
}
/**
 * コンテナを下辺までスクロールします。
 * @param options
 */
function scrollToBottom(options) {
    return scrollToSide('bottom', options);
}
/**
 * コンテナを左辺までスクロールします。
 * @param options
 */
function scrollToLeft(options) {
    return scrollToSide('left', options);
}
/**
 * コンテナを左上コーナーまでスクロールします。
 * @param options
 */
function scrollToLeftTop(options) {
    return scrollToSide(['left', 'top'], options);
}
/**
 * コンテナを左下コーナーまでスクロールします。
 * @param options
 */
function scrollToLeftBottom(options) {
    return scrollToSide(['left', 'bottom'], options);
}
/**
 * コンテナを右上コーナーまでスクロールします。
 * @param options
 */
function scrollToRightTop(options) {
    return scrollToSide(['right', 'top'], options);
}
/**
 * コンテナを右下コーナーまでスクロールします。
 * @param options
 */
function scrollToRightBottom(options) {
    return scrollToSide(['right', 'bottom'], options);
}

/**
 * Scrollerの状態を示します。
 */
var ScrollerState;
(function (ScrollerState) {
    /**
     * Scrollerが初期化されていない（Elementが設定されていない）状態を示します。
     */
    ScrollerState["Pending"] = "pending";
    /**
     * Scrollerが初期化されているが、[[Scroller.el]]のリサイズやスクロールのイベント監視が動作していない状態を示します。
     */
    ScrollerState["Ready"] = "ready";
    /**
     * Scrollerが初期化されていて、[[Scroller.el]]のリサイズやスクロールのイベント監視が動作している状態を示します。
     */
    ScrollerState["Running"] = "running";
    /**
     * [[Scroller.destroy]]が実行され、Scrollerが利用不可である状態を示します。
     */
    ScrollerState["Destroyed"] = "destroyed";
})(ScrollerState || (ScrollerState = {}));
var scrollerObservableKeys = [
    'state',
    'isPending',
    'isReady',
    'isRunning',
    'isDestroyed',
    'scrollEnabled',
    'containerWidth',
    'containerHeight',
    'scrollWidth',
    'scrollHeight',
    'scrollableX',
    'scrollableY',
    'scrollTop',
    'scrollLeft',
    'scrollRight',
    'scrollBottom',
    'lastAxis',
    'lastDirection',
    'lastYDirection',
    'lastXDirection',
    'nowScrolling',
];
/**
 * 任意のElement（or HTML Document）のスクロールやサイズ変更を監視し、その情報を通知するクラスです。<br>
 * <a href="https://dadajam4.github.io/dadajam4/ev/classes/_ev_.ev.html" target="_blank">EV</a>を継承しており、イベントの購読[[Scroller.on]]等のインターフェースを利用するか、
 * [[Scroller.observe]]メソッドを利用します。<br>
 * [[Scroller.on]]、[[Scroller.once]]で購読可能なイベントについては[[ScrollerEventMap]]を参照してください。
 */
var Scroller = /** @class */ (function (_super) {
    __extends(Scroller, _super);
    /**
     * Scrollerインスタンスを作成します。
     * コンテキストとなるElementをこの時点で指定するか否かは任意です。
     *
     * @param settingOrElementOrQueryString 任意です。[[ScrollerSetting]]か Element（or cssクエリセレクタ文字列）を直接指定します。この時点でElementを指定しない場合は、[[setElement]]を実行するまでインスタンスは動作しません。
     */
    function Scroller(settingOrElementOrQueryString) {
        if (settingOrElementOrQueryString === void 0) { settingOrElementOrQueryString = {}; }
        var _this = _super.call(this) || this;
        /**
         * スクロールを検知してから、移動がなくなった際に、何ms後にスクロール終了と判定するかのインターバル値を示します。
         * デフォルトは500です。
         */
        _this.scrollingJudgeInterval = 500;
        /**
         * 縦、横のどちらのスクロールを基準とするかを示します。
         * デフォルトはyです。<br>
         * この設定は[[Scroller.toElement]]のデフォルト値にも影響します。
         */
        _this.baseAxis = 'y';
        /**
         * スクロール系メソッド[[Scroller.to]]等を利用する際のデフォルトの設定を示します。
         */
        _this.scrollSettingsDefaults = __assign({}, defaultBaseSettings);
        /**
         * [[Scroller.toElement]]のデフォルトオプションの設定を示します。
         */
        _this.scrollToElementSettingsDefaults = __assign({}, scrollToElementSettingsDefaults);
        _this._isDocumentElement = false;
        _this._isBodyElement = false;
        _this._isRootElement = false;
        _this._state = ScrollerState.Pending;
        _this._containerWidth = 0;
        _this._containerHeight = 0;
        _this._scrollWidth = 0;
        _this._scrollHeight = 0;
        _this._scrollTop = 0;
        _this._scrollRight = 0;
        _this._scrollBottom = 0;
        _this._scrollLeft = 0;
        _this._lastYDirection = 'top';
        _this._lastXDirection = 'left';
        _this._nowScrolling = false;
        _this._readyResolvers = [];
        _this._scrollingJudgeTimerId = null;
        _this._startX = 0;
        _this._startY = 0;
        _this._tickedX = 0;
        _this._tickedY = 0;
        _this._lastTotalX = 0;
        _this._lastTotalY = 0;
        _this._scrollToResult = null;
        _this._observers = [];
        _this._scrollStoppers = [];
        _this._scrollSizeOvserverPollingId = null;
        _this._scrollSizeOvserverSuspended = false;
        var convertedSetting = typeof settingOrElementOrQueryString === 'string' ||
            settingOrElementOrQueryString === null ||
            (HAS_WINDOW && settingOrElementOrQueryString instanceof Element)
            ? (settingOrElementOrQueryString = {
                el: settingOrElementOrQueryString,
            })
            : settingOrElementOrQueryString;
        if (convertedSetting.scrollingJudgeInterval !== undefined)
            _this.scrollingJudgeInterval = convertedSetting.scrollingJudgeInterval;
        if (convertedSetting.baseAxis)
            _this.baseAxis = convertedSetting.baseAxis;
        _this._lastAxis = _this.baseAxis;
        var scrollSizeOvserver = convertedSetting.scrollSizeOvserver;
        if (scrollSizeOvserver) {
            _this.scrollSizeOvserver = __assign({ interval: 500, width: true, height: true }, scrollSizeOvserver);
        }
        _this._visibilityListener = function () {
            if (visibilityManager.isVisible) {
                _this.update();
                if (_this._scrollSizeOvserverSuspended) {
                    _this._scrollSizeOvserverSuspended = false;
                    _this._startScrollSizeOvserver();
                }
            }
            else {
                _this._scrollSizeOvserverSuspended = _this._scrollSizeOvserverPollingId !== null;
                _this._stopScrollSizeOvserver();
            }
        };
        _this._lastDirection = _this._lastAxis === 'y' ? 'top' : 'left';
        // for SSR
        if (!HAS_WINDOW)
            return _this;
        // Add Visibility Listener
        visibilityManager.change(_this._visibilityListener);
        // Skip auto setup when missing scrolling element.
        _this.setElement(convertedSetting.el);
        return _this;
    }
    Object.defineProperty(Scroller.prototype, "el", {
        /**
         * 設定されたElement要素です。
         * 初期化が完了していない時には本getterはundefinedを返却する事に注意してください。
         */
        get: function () {
            return this._el;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "state", {
        /**
         * 現在の状態です。<br>
         * @see: [[ScrollerState]]
         */
        get: function () {
            return this._state;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "isPending", {
        /**
         * 未初期化である場合trueを示します。
         */
        get: function () {
            return this._state === ScrollerState.Pending;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "isReady", {
        /**
         * 初期化済み＆停止状態である場合trueを示します。
         */
        get: function () {
            return this._state === ScrollerState.Ready;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "isRunning", {
        /**
         * 初期化済み＆動作中である場合trueを示します。
         */
        get: function () {
            return this._state === ScrollerState.Running;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "isDestroyed", {
        /**
         * インスタンスが破棄済みである場合trueを示します。
         */
        get: function () {
            return this._state === ScrollerState.Destroyed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "scrollEnabled", {
        /**
         * スクロールの有効状態を取得します
         */
        get: function () {
            return this._scrollStoppers.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "containerWidth", {
        /**
         * スクロール要素の幅を示します。
         */
        get: function () {
            return this._containerWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "containerHeight", {
        /**
         * スクロール要素の高さを示します。
         */
        get: function () {
            return this._containerHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "scrollWidth", {
        /**
         * スクロール要素内のコンテンツの幅を示します。
         */
        get: function () {
            return this._scrollWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "scrollHeight", {
        /**
         * スクロール要素内のコンテンツの高さを示します。
         */
        get: function () {
            return this._scrollHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "scrollableX", {
        /**
         * x軸にスクロール可能な場合trueを示します
         */
        get: function () {
            return this._scrollWidth > this._containerWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "scrollableY", {
        /**
         * y軸にスクロール可能な場合trueを示します
         */
        get: function () {
            return this._scrollHeight > this._containerHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "scrollTop", {
        /**
         * 現在の上辺からのスクロール量を示します。
         */
        get: function () {
            return this._scrollTop;
        },
        /**
         * 上辺からのスクロール量を設定します。
         */
        set: function (scrollTop) {
            if (!this.el)
                return;
            this.el.scrollTop = scrollTop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "scrollRight", {
        /**
         * 現在の右辺からのスクロール量を示します。
         */
        get: function () {
            return this._scrollRight;
        },
        /**
         * 右辺からのスクロール量を設定します。
         */
        set: function (scrollRight) {
            if (!this.el)
                return;
            this.el.scrollLeft = this._scrollWidth - this._containerWidth - scrollRight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "scrollBottom", {
        /**
         * 現在の下辺からのスクロール量を示します。
         */
        get: function () {
            return this._scrollBottom;
        },
        /**
         * 下辺からのスクロール量を設定します。
         */
        set: function (scrollBottom) {
            if (!this.el)
                return;
            this.el.scrollTop =
                this._scrollHeight - this._containerHeight - scrollBottom;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "scrollLeft", {
        /**
         * 現在の左辺からのスクロール量を示します。
         */
        get: function () {
            return this._scrollLeft;
        },
        /**
         * 左辺からのスクロール量を設定します。
         */
        set: function (scrollLeft) {
            if (!this.el)
                return;
            this.el.scrollLeft = scrollLeft;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "nowScrolling", {
        /**
         * 現在スクロール中である場合trueを示します。
         */
        get: function () {
            return this._nowScrolling;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "lastAxis", {
        /**
         * 最後に検知したスクロールの軸を示します。
         */
        get: function () {
            return this._lastAxis;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "lastDirection", {
        /**
         * 最後に検知したスクロールの方向を示します。
         */
        get: function () {
            return this._lastDirection;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "lastYDirection", {
        /**
         * 最後に検知したスクロールの垂直方向を示します。
         */
        get: function () {
            return this._lastYDirection;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "lastXDirection", {
        /**
         * 最後に検知したスクロールの水平方向を示します。
         */
        get: function () {
            return this._lastXDirection;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scroller.prototype, "lastPayload", {
        /**
         * 最後に検知したスクロールにより通知した情報を示します。
         */
        get: function () {
            return {
                top: this._scrollTop,
                left: this._scrollLeft,
                bottom: this._scrollBottom,
                right: this._scrollRight,
                axis: this._lastAxis,
                direction: this._lastDirection,
                directionX: this._lastXDirection,
                directionY: this._lastYDirection,
                tickedX: this._tickedX,
                tickedY: this._tickedY,
                totalX: this._lastTotalX,
                totalY: this._lastTotalY,
            };
        },
        enumerable: true,
        configurable: true
    });
    /**
     * インスタンスにElementを設定します。特別な理由（SSRの利用等）によりコンストラクタでElementを指定できない場合、
     * 本メソッドを利用しブラウザコンテキスト配下で本メソッドを実行してください。
     * @param el Element、もしくはCSSクエリセレクタ文字列を指定します。
     */
    Scroller.prototype.setElement = function (el) {
        if (el === null)
            return;
        this.stop();
        var _el;
        if (typeof el === 'string') {
            _el = document.querySelector(el);
        }
        else {
            _el = el || document.scrollingElement;
        }
        if (!_el)
            throw error('missing scrolling element ' + el);
        this._el = _el;
        this._isDocumentElement = isDocumentElement(_el);
        this._isBodyElement = isBodyElement(_el);
        this._isRootElement = this._isDocumentElement || this._isBodyElement;
        this._eventTarget =
            this._isDocumentElement || this._isBodyElement ? window : this._el;
        this._setup();
    };
    /**
     * インスタンスが実行可能になった際にresolveされるPromiseインスタンスを返却します。
     */
    Scroller.prototype.ready = function () {
        var _this = this;
        this._checkDestroyed();
        if (!this.isPending)
            return Promise.resolve();
        return new Promise(function (resolve) { return _this._readyResolvers.push(resolve); });
    };
    /**
     * インスタンスの動作を開始します。本インスタンスはElementが設定され初期化された際に自動で動作を開始しますが、
     * [[Scroller.stop]]メソッドを利用し動作を停止した後に再開する場合に本メソッドを利用します。
     */
    Scroller.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._checkDestroyed();
                        if (this.isRunning)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.ready()];
                    case 1:
                        _a.sent();
                        this._startListeners();
                        this._setState(ScrollerState.Running);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * インスタンスの動作（スクロール、リサイズイベントの検知等）を停止します。
     * 何らかの理由で動作を停止させたい場合に利用してください。
     * 本メソッドを実行後もインスタンス内の状態は保持されたままです。
     * 完全にインスタンスを破棄するためには[[Scroller.destroy]]を利用してください。
     */
    Scroller.prototype.stop = function () {
        this._checkDestroyed();
        if (!this.isRunning)
            return;
        this._stopListeners();
        this._setState(ScrollerState.Ready);
    };
    /**
     * インスタンスの動作を停止し、内部情報を完全に破棄します。
     * これに伴い、スクロール中であった場合にはキャンセルされ、以後イベント通知は完全に行われません。
     * また[[Scroller.start]]メソッドでの再利用も不可となります。
     * 本インスタンスの利用を完全に停止する場合に必ず実行し、利用側のオブジェクト等において本インスタンスへの参照を完全に削除してください。
     * 本メソッドはSPA等でのサービスにおいては意識的に実行する事を強く推奨します。
     */
    Scroller.prototype.destroy = function () {
        if (this.isDestroyed)
            return;
        this.stop();
        this.cancel();
        this._readyResolvers = [];
        this._scrollStoppers = [];
        this._scrollEnable();
        this._observers = [];
        visibilityManager.remove(this._visibilityListener);
        delete this._el;
        delete this._eventTarget;
        delete this._scrollListener;
        delete this._resizeListener;
        delete this._resizeObserver;
        delete this._scrollToResult;
        delete this._visibilityListener;
        this._setState(ScrollerState.Destroyed);
        this.offAll();
    };
    /**
     * インスタンス内部のスクロール量や、Elementのサイズを強制的に更新します。
     * 基本的に利用が必要なケースはありませんが、何らかの理由で更新をトリガーしたい場合に利用します。
     */
    Scroller.prototype.update = function () {
        this._update();
    };
    /**
     * インスタンス内の情報をjsonオブジェクトとして返却します。
     * 情報の詳細は[[ScrollerObserver]]を参照してください。
     */
    Scroller.prototype.toJSON = function () {
        var e_1, _a;
        var json = {};
        try {
            for (var scrollerObservableKeys_1 = __values(scrollerObservableKeys), scrollerObservableKeys_1_1 = scrollerObservableKeys_1.next(); !scrollerObservableKeys_1_1.done; scrollerObservableKeys_1_1 = scrollerObservableKeys_1.next()) {
                var key = scrollerObservableKeys_1_1.value;
                json[key] = this[key];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (scrollerObservableKeys_1_1 && !scrollerObservableKeys_1_1.done && (_a = scrollerObservableKeys_1.return)) _a.call(scrollerObservableKeys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return json;
    };
    /**
     * [[Scroller.toJSON]]の情報を文字列として返却します。
     */
    Scroller.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    /**
     * 本インスタンスの情報を購読するためのオブジェクトを設定する事で、
     * インスタンスの内部情報が変更される度にパラメータが同期されます。
     * 設定するオブジェクトは[[ScrollerObserver]]のインターフェースを満たしていれば内容は問いません。
     * 本機能により同期される方法は単純にオブジェクトプロパティへの変数代入です。
     * 従って対象となるプロパティをgetterとして実装（Ex: Vue computed等、、）しておく事により、
     * 同期を受け取るオブジェクト側でパラメータ変更後の動作をリアクティブに実装可能です。
     * @param observer 同期させたいオブジェクト
     * @returns unobserve 同期を停止するためのメソッド
     */
    Scroller.prototype.observe = function (observer) {
        var _this = this;
        if (!this._observers.includes(observer)) {
            this._observers.push(observer);
        }
        this._syncToObserver(observer);
        var unobserve = function () {
            _this.unobserve(observer);
        };
        return unobserve;
    };
    /**
     * [[Scroller.observe]]でパラメータ同期中のオブジェクトを停止します。
     * [[Scroller.destroy]]実行時にも、同期中のオブジェクトは全停止されますが、destroy前に任意のタイミングで停止したい場合
     * 本メソッドを利用します。
     * @param observer 同期中のオブジェクト
     */
    Scroller.prototype.unobserve = function (observer) {
        var index = this._observers.indexOf(observer);
        if (index !== -1) {
            this._observers.splice(index, 1);
        }
    };
    /**
     * スクロール中であった場合、スクロールをキャンセルします。
     */
    Scroller.prototype.cancel = function () {
        if (!this._scrollToResult)
            return;
        this._scrollToResult.cancel();
        this._clearScrollToResult();
    };
    /**
     * x, yの差分pxを指定しスクロールします。
     * メソッド、パラメータの詳細は[[scrollBy]]を参照してください。
     * @param diffX 横移動量
     * @param diffY 縦移動量
     * @param options
     */
    Scroller.prototype.by = function (diffX, diffY, options) {
        return this._setScrollToResult(scrollBy(diffX, diffY, this._createMergedScrollOptions(options)));
    };
    /**
     * 指定の座標をスクロールします。
     * メソッド、パラメータの詳細は[[scrollTo]]を参照してください。
     * @param scrollPosition
     * @param options
     */
    Scroller.prototype.to = function (scrollPosition, options) {
        return this._setScrollToResult(scrollTo(scrollPosition, this._createMergedScrollOptions(options)));
    };
    /**
     * 指定の要素の位置へスクロールします。
     * メソッド、パラメータの詳細は[[scrollToElement]]を参照してください。
     * オプションのx, yが未設定であった場合、[[Scroller.baseAxis]]により自動設定されます。
     * @param target
     * @param options
     */
    Scroller.prototype.toElement = function (target, options) {
        var merged = this._createMergedScrollToElementOptions(options);
        if (merged.x === undefined)
            merged.x = this.baseAxis === 'x';
        if (merged.y === undefined)
            merged.y = this.baseAxis === 'y';
        return this._setScrollToResult(scrollToElement(target, merged));
    };
    /**
     * 指定の辺へスクロールします。
     * メソッド、パラメータの詳細は[[scrollToSide]]を参照してください。
     * @param targets
     * @param options
     */
    Scroller.prototype.toSide = function (targets, options) {
        return this._setScrollToResult(scrollToSide(targets, this._createMergedScrollOptions(options)));
    };
    /**
     * 上辺へスクロールします。
     * メソッド、パラメータの詳細は[[scrollToTop]]を参照してください。
     * @param options
     */
    Scroller.prototype.toTop = function (options) {
        return this._setScrollToResult(scrollToTop(this._createMergedScrollOptions(options)));
    };
    /**
     * 右辺へスクロールします。
     * メソッド、パラメータの詳細は[[scrollToRight]]を参照してください。
     * @param options
     */
    Scroller.prototype.toRight = function (options) {
        return this._setScrollToResult(scrollToRight(this._createMergedScrollOptions(options)));
    };
    /**
     * 下辺へスクロールします。
     * メソッド、パラメータの詳細は[[scrollToBottom]]を参照してください。
     * @param options
     */
    Scroller.prototype.toBottom = function (options) {
        return this._setScrollToResult(scrollToBottom(this._createMergedScrollOptions(options)));
    };
    /**
     * 左辺へスクロールします。
     * メソッド、パラメータの詳細は[[scrollToLeft]]を参照してください。
     * @param options
     */
    Scroller.prototype.toLeft = function (options) {
        return this._setScrollToResult(scrollToLeft(this._createMergedScrollOptions(options)));
    };
    /**
     * 左上コーナーへスクロールします。
     * メソッド、パラメータの詳細は[[scrollToLeftTop]]を参照してください。
     * @param options
     */
    Scroller.prototype.toLeftTop = function (options) {
        return this._setScrollToResult(scrollToLeftTop(this._createMergedScrollOptions(options)));
    };
    /**
     * 左下コーナーへスクロールします。
     * メソッド、パラメータの詳細は[[scrollToLeftBottom]]を参照してください。
     * @param options
     */
    Scroller.prototype.toLeftBottom = function (options) {
        return this._setScrollToResult(scrollToLeftBottom(this._createMergedScrollOptions(options)));
    };
    /**
     * 右上コーナーへスクロールします。
     * メソッド、パラメータの詳細は[[scrollToRightTop]]を参照してください。
     * @param options
     */
    Scroller.prototype.toRightTop = function (options) {
        return this._setScrollToResult(scrollToRightTop(this._createMergedScrollOptions(options)));
    };
    /**
     * 右下コーナーへスクロールします。
     * メソッド、パラメータの詳細は[[scrollToRightBottom]]を参照してください。
     * @param options
     */
    Scroller.prototype.toRightBottom = function (options) {
        return this._setScrollToResult(scrollToRightBottom(this._createMergedScrollOptions(options)));
    };
    /**
     * スクロールの停止を要求します。
     * @param stopper
     */
    Scroller.prototype.pushScrollStopper = function (stopper) {
        var _this = this;
        if (!this._scrollStoppers.includes(stopper)) {
            this._scrollStoppers.push(stopper);
            if (this._scrollStoppers.length === 1) {
                this._updateScrollable();
                this._syncToObservers(['scrollEnabled']);
            }
        }
        return function () {
            _this.removeScrollStopper(stopper);
        };
    };
    /**
     * スクロールの停止要求を解除します。<br>
     * 別のプロセスにより異なる[[ScrollStopper]]が登録されている場合、
     * スクロールは再開されない事に注意してください。
     * @param stopper
     */
    Scroller.prototype.removeScrollStopper = function (stopper) {
        var index = this._scrollStoppers.indexOf(stopper);
        if (index !== -1) {
            this._scrollStoppers.splice(index, 1);
            if (this._scrollStoppers.length === 0) {
                this._updateScrollable();
                this._syncToObservers(['scrollEnabled']);
            }
        }
    };
    Scroller.prototype._setup = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._updateScrollable();
                this._update();
                this._setState(ScrollerState.Ready);
                this.start();
                this.emit('ready', undefined);
                this._readyResolvers.forEach(function (resolve) { return resolve(); });
                this._readyResolvers = [];
                return [2 /*return*/];
            });
        });
    };
    Scroller.prototype._setState = function (state) {
        if (this._state !== state) {
            this._state = state;
            this._syncToObservers([
                'state',
                'isPending',
                'isReady',
                'isRunning',
                'isDestroyed',
            ]);
            this.emit('changeState', state);
        }
    };
    Scroller.prototype._checkDestroyed = function () {
        if (this.isDestroyed)
            throw error('already destroyed.');
    };
    Scroller.prototype._update = function (width, height) {
        this._updateContainerSize(width, height);
        this._updateScrollSize();
        this._updateScrollPositions();
    };
    Scroller.prototype._updateContainerSize = function (width, height) {
        var _a = this, el = _a.el, _isBodyElement = _a._isBodyElement;
        if (width === undefined) {
            if (!el)
                return;
            width = _isBodyElement ? document.documentElement.clientWidth : el.clientWidth;
        }
        if (height === undefined) {
            if (!el)
                return;
            height = _isBodyElement ? document.documentElement.clientHeight : el.clientHeight;
        }
        var _b = this, _containerWidth = _b._containerWidth, _containerHeight = _b._containerHeight;
        this._containerWidth = width;
        this._containerHeight = height;
        if (width !== _containerWidth || height !== _containerHeight) {
            this._syncToObservers([
                'containerWidth',
                'containerHeight',
                'scrollableX',
                'scrollableY',
            ]);
            this.emit('resize', { width: width, height: height });
        }
    };
    Scroller.prototype._updateScrollSize = function () {
        var _a = this, el = _a.el, _scrollWidth = _a._scrollWidth, _scrollHeight = _a._scrollHeight;
        if (!el)
            return;
        this._scrollWidth = el.scrollWidth;
        this._scrollHeight = el.scrollHeight;
        if (_scrollWidth !== this._scrollWidth ||
            _scrollHeight !== this._scrollHeight) {
            this._syncToObservers([
                'scrollWidth',
                'scrollHeight',
                'scrollableX',
                'scrollableY',
            ]);
        }
    };
    Scroller.prototype._startScrollSizeOvserver = function () {
        var _this = this;
        if (!HAS_WINDOW)
            return;
        this._stopScrollSizeOvserver();
        if (this.scrollSizeOvserver) {
            this._scrollSizeOvserverPollingId = window.setInterval(function () {
                if (!_this.scrollSizeOvserver || _this.isDestroyed) {
                    _this._stopScrollSizeOvserver();
                    return;
                }
                _this._updateScrollSize();
            }, this.scrollSizeOvserver.interval);
        }
    };
    Scroller.prototype._stopScrollSizeOvserver = function () {
        if (this._scrollSizeOvserverPollingId !== null) {
            clearInterval(this._scrollSizeOvserverPollingId);
            this._scrollSizeOvserverPollingId = null;
        }
    };
    Scroller.prototype._updateScrollPositions = function () {
        if (!this.el)
            return;
        this._scrollTop = this.el.scrollTop;
        this._scrollLeft = this.el.scrollLeft;
        // advanced values
        this._scrollBottom =
            this._scrollHeight - this._scrollTop - this._containerHeight;
        this._scrollRight =
            this._scrollWidth - this._scrollLeft - this._containerWidth;
        this._syncToObservers([
            'scrollTop',
            'scrollRight',
            'scrollBottom',
            'scrollLeft',
        ]);
    };
    Scroller.prototype._startListeners = function () {
        var _this = this;
        this._stopListeners();
        this._scrollListener = function () {
            _this._onScroll();
        };
        this._eventTarget.addEventListener('scroll', this._scrollListener, false);
        if (this._isRootElement) {
            this._resizeListener = function () {
                _this._onResize();
            };
            window.addEventListener('resize', this._resizeListener, false);
        }
        else {
            this._resizeObserver = new ResizeObserver(function (entries) {
                var e_2, _a;
                try {
                    for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                        var entry = entries_1_1.value;
                        var _b = entry.contentRect, width = _b.width, height = _b.height;
                        _this._onResize(width, height);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            });
            this._el && this._resizeObserver.observe(this._el);
        }
        if (visibilityManager.isVisible) {
            this._scrollSizeOvserverSuspended = false;
            this._startScrollSizeOvserver();
        }
        else {
            this._scrollSizeOvserverSuspended = true;
        }
    };
    Scroller.prototype._stopListeners = function () {
        if (this._scrollListener) {
            this._eventTarget.removeEventListener('scroll', this._scrollListener, false);
            delete this._scrollListener;
        }
        if (this._resizeListener) {
            if (this._isDocumentElement) {
                window.removeEventListener('resize', this._resizeListener, false);
                delete this._resizeListener;
            }
        }
        if (this._resizeObserver && this._el) {
            this._resizeObserver.unobserve(this._el);
            this._resizeObserver.disconnect();
            delete this._resizeObserver;
        }
    };
    Scroller.prototype._clearScrollingJudgeTimer = function () {
        if (this._scrollingJudgeTimerId !== null) {
            clearTimeout(this._scrollingJudgeTimerId);
            this._scrollingJudgeTimerId = null;
        }
    };
    Scroller.prototype._onResize = function (width, height) {
        this._update(width, height);
    };
    Scroller.prototype._triggerScrollTick = function (event) {
        var _nowScrolling = this._nowScrolling;
        if (event === 'scrollStart') {
            this._startX = this._scrollLeft;
            this._startY = this._scrollTop;
            this._lastTotalX = 0;
            this._lastTotalY = 0;
            this._nowScrolling = true;
        }
        else if (event === 'scrollEnd') {
            this._nowScrolling = false;
        }
        if (_nowScrolling !== this._nowScrolling) {
            this._syncToObservers('nowScrolling');
        }
        this.emit(event, this.lastPayload);
    };
    Scroller.prototype._onScroll = function () {
        var _this = this;
        if (!this.scrollEnabled && this._el) {
            this._el.scrollLeft = this._scrollLeft;
            this._el.scrollTop = this._scrollTop;
            return;
        }
        // remenber before values
        var _a = this, _scrollTop = _a._scrollTop, _scrollLeft = _a._scrollLeft, _lastAxis = _a._lastAxis, _lastDirection = _a._lastDirection, _lastXDirection = _a._lastXDirection, _lastYDirection = _a._lastYDirection;
        // ,,,and next update values
        this._updateScrollPositions();
        // calicurate scrolled ammount at (ticked time)
        var tickedX = this._scrollLeft - _scrollLeft;
        var tickedY = this._scrollTop - _scrollTop;
        this._tickedX = tickedX;
        this._tickedY = tickedY;
        // update axis
        if (tickedX === tickedY) {
            this._lastAxis = this.baseAxis;
        }
        else {
            this._lastAxis = Math.abs(tickedX) > Math.abs(tickedY) ? 'x' : 'y';
        }
        // update directions
        if (_scrollTop < this._scrollTop) {
            this._lastYDirection = 'bottom';
        }
        else if (_scrollTop > this._scrollTop) {
            this._lastYDirection = 'top';
        }
        if (_scrollLeft < this._scrollLeft) {
            this._lastXDirection = 'right';
        }
        else if (_scrollLeft > this._scrollLeft) {
            this._lastXDirection = 'left';
        }
        this._lastDirection =
            this._lastAxis === 'y' ? this._lastYDirection : this._lastXDirection;
        // judge scroll end by before axis and directions
        var axisIsChanged = this._lastAxis !== _lastAxis;
        var lastXDirectionIsChanged = this._lastXDirection !== _lastXDirection;
        var lastYDirectionIsChanged = this._lastYDirection !== _lastYDirection;
        var lastDirectionIsChanged = this._lastDirection !== _lastDirection;
        if (axisIsChanged) {
            this.emit('changeAxis', this._lastAxis);
        }
        if (lastXDirectionIsChanged) {
            this.emit('changeLastXDirection', this._lastXDirection);
        }
        if (lastYDirectionIsChanged) {
            this.emit('changeLastYDirection', this._lastYDirection);
        }
        if (lastDirectionIsChanged) {
            this.emit('changeLastDirection', this._lastDirection);
        }
        if (axisIsChanged ||
            lastXDirectionIsChanged ||
            lastYDirectionIsChanged ||
            lastDirectionIsChanged) {
            this._syncToObservers([
                'lastAxis',
                'lastDirection',
                'lastYDirection',
                'lastXDirection',
            ]);
        }
        if (this._nowScrolling) {
            if (axisIsChanged ||
                (_lastAxis === 'y' && lastYDirectionIsChanged) ||
                (_lastAxis === 'x' && lastXDirectionIsChanged)) {
                // emit scroll end & start(both)
                this._triggerScrollTick('scrollEnd');
            }
            else {
                // add scroll ammounts
                this._lastTotalX = this._scrollLeft - this._startX;
                this._lastTotalY = this._scrollTop - this._startY;
                this._triggerScrollTick('scroll');
            }
        }
        // judge scroll start
        if (!this._nowScrolling) {
            this._updateScrollSize();
            this._triggerScrollTick('scrollStart');
        }
        this._clearScrollingJudgeTimer();
        this._scrollingJudgeTimerId = window.setTimeout(function () {
            _this._triggerScrollTick('scrollEnd');
        }, this.scrollingJudgeInterval);
    };
    Scroller.prototype._syncToObserver = function (observer, keys) {
        var e_3, _a;
        if (keys === void 0) { keys = scrollerObservableKeys; }
        try {
            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var key = keys_1_1.value;
                observer[key] = this[key];
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    Scroller.prototype._syncToObservers = function (keys) {
        var e_4, _a;
        if (this._observers.length === 0)
            return;
        keys = typeof keys === 'string' ? [keys] : keys;
        try {
            for (var _b = __values(this._observers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var observer = _c.value;
                this._syncToObserver(observer, keys);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    Scroller.prototype._createMergedScrollOptions = function (source) {
        if (!this._el)
            throw error('missing element');
        var merged = __assign({ container: this._el }, this.scrollSettingsDefaults, source);
        return merged;
    };
    Scroller.prototype._createMergedScrollToElementOptions = function (source) {
        if (!this._el)
            throw error('missing element');
        var merged = __assign({ container: this._el }, this.scrollToElementSettingsDefaults, source);
        return merged;
    };
    Scroller.prototype._clearScrollToResult = function () {
        if (!this._scrollToResult)
            return;
        this._scrollToResult = null;
    };
    Scroller.prototype._setScrollToResult = function (result) {
        var _this = this;
        this._scrollToResult = result;
        result.promise.then(function () {
            _this._clearScrollToResult();
        });
        return result;
    };
    Scroller.prototype._updateScrollable = function () {
        if (this.scrollEnabled) {
            this._scrollEnable();
        }
        else {
            this._scrollDisable();
        }
    };
    Scroller.prototype._scrollEnable = function () {
        if (!this._el)
            throw error('missing element');
        enableScroll(this._el);
    };
    Scroller.prototype._scrollDisable = function () {
        if (!this._el)
            throw error('missing element');
        this.cancel();
        disableScroll(this._el);
    };
    /**
     * Scrollerクラスの状態を監視＆同期するオブジェクトが
     * 保有すべきプロパティ一のキーの配列です。
     */
    Scroller.scrollerObservableKeys = scrollerObservableKeys;
    /**
     * Scrollerの状態を示すenum値です。<br>
     * @see [[ScrollerState]]
     */
    Scroller.States = ScrollerState;
    return Scroller;
}(EV));

export default Scroller;
export { ScrollerState, SCROLLABLE_KEY_CODES, enableScroll, disableScroll, defaultBaseSettings, scrollBy, scrollTo, scrollToElement, scrollToSide, SUPPORTS_PASSIVE, scrollToElementSettingsDefaults, scrollToTop, scrollToRight, scrollToBottom, scrollToLeft, scrollToLeftTop, scrollToLeftBottom, scrollToRightTop, scrollToRightBottom };
